import React from "react";
import { Button, Col, FloatingLabel, Form, Row } from "react-bootstrap";
import { useGetTemplateFetch } from "../../../../../../queries/query-hooks/workspace/emsl-hook";
import { typeOfChannel } from "../../utils/constants";
import { findIcon } from "views/dashboard/icons";

const EmslRemainder = ({
  index = 0,
  remainders = [],
  setRemainders = () => {},
}) => {
  const { data: smsTemplateData, isLoading: isSmsTamplateDataLoading } =
    useGetTemplateFetch("sms", remainders[index]?.channels?.sms);
  const { data: emailTemplateData, isLoading: isEmailTamplateDataLoading } =
    useGetTemplateFetch("email", remainders[index]?.channels?.email);
  const {
    data: whatsApptemplateData,
    isLoading: isWhatsAppTamplateDataLoading,
  } = useGetTemplateFetch("whatsapp", remainders[index]?.channels?.whatsapp);

  const templateOptions = {
    sms: smsTemplateData?.map((t) => ({ value: t.id, label: t.name })) || [],
    email:
      emailTemplateData?.map((t) => ({ value: t.id, label: t.name })) || [],
    whatsapp:
      whatsApptemplateData?.map((t) => ({ value: t.id, label: t.name })) || [],
  };

  const handleChange = (type, value) => {
    setRemainders((prevRemainders) => {
      const newRemainders = [...prevRemainders];
      newRemainders[index]["time"][type] = value;
      return newRemainders;
    });
  };

  const handleCheckboxChange = (e) => {
    const channel = e.target.name;
    const checked = e.target.checked;

    setRemainders((prevRemainders) => {
      const newRemainders = [...prevRemainders];
      newRemainders[index]["channels"][channel] = checked;
      return newRemainders;
    });

    if (!checked) {
      setRemainders((prevRemainders) => {
        const newRemainders = [...prevRemainders];
        newRemainders[index]["template"][channel] = null;
        return newRemainders;
      });
    }
  };

  const handleDropdownChange = (e, channel) => {
    const selectedId = e.target.value;
    const selectedOption = templateOptions[channel].find(
      (opt) => String(opt.value) === selectedId
    );

    setRemainders((prevRemainders) => {
      const newRemainders = [...prevRemainders];
      newRemainders[index]["template"][channel] = {
        id: selectedOption?.value || "",
        name: selectedOption?.label || "",
      };
      return newRemainders;
    });
  };
  function getOrdinal(n) {
    const lastDigit = n % 10;
    const lastTwoDigits = n % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) return `${n}th`;

    switch (lastDigit) {
      case 1:
        return `${n}st`;
      case 2:
        return `${n}nd`;
      case 3:
        return `${n}rd`;
      default:
        return `${n}th`;
    }
  }

  return (
    <div className="border border-1 border-primary border-opacity-25 border-dashed rounded-3 mb-4 p-4 px-3">
      <p className="mb-3 fs-6">{`${getOrdinal(index + 1)} Remainder`}</p>
      <Row>
        <Col md="4" xs="12">
          <FloatingLabel
            controlId={`dropdown-survery-type`}
            label={`Select Survey Type`}
            className="custom-form-floating mb-4"
          >
            <Form.Select
              value={remainders[index]?.surveyType}
              onChange={(e) =>
                setRemainders((prev) => [
                  ...prev.slice(0, index),
                  { ...prev[index], surveyType: e.target.value },
                  ...prev.slice(index + 1),
                ])
              }
            >
              <option value="">Select Survey Type</option>
              <option value="hcp">HCP</option>
              <option value="nps">NPS</option>
            </Form.Select>
          </FloatingLabel>
        </Col>
        <Col md="4" xs="12">
          <FloatingLabel
            controlId="floatingNumber"
            label={
              <>
                {"Survey ID"}
                {<span className="text-danger"> *</span>}
              </>
            }
            className="custom-form-floating mb-4"
          >
            <Form.Control
              type="number"
              placeholder="Number"
              min={0}
              value={remainders[index]?.spqId}
              onChange={(e) => {
                setRemainders((prev) => [
                  ...prev.slice(0, index),
                  { ...prev[index], spqId: e.target.value },
                  ...prev.slice(index + 1),
                ]);
              }}
            />
          </FloatingLabel>
        </Col>
        <Col md="4" xs="12" className="d-flex gap-3">
          <FloatingLabel
            controlId="floatingDay"
            label={
              <>
                Day <span className="text-danger">*</span>
              </>
            }
            className="custom-form-floating flex-fill mb-4"
          >
            <Form.Select
              value={remainders[index]["time"]?.day}
              onChange={(e) => handleChange("day", e.target.value)}
            >
              <option value="">Day</option>
              {[...Array(7).keys()].map((d) => (
                <option key={d} value={d + 1}>
                  {d + 1}
                </option>
              ))}
            </Form.Select>
          </FloatingLabel>

          <FloatingLabel
            controlId="floatingHour"
            label={
              <>
                Hour <span className="text-danger">*</span>
              </>
            }
            className="custom-form-floating flex-fill mb-4"
          >
            <Form.Select
              value={remainders[index]["time"]?.hour}
              onChange={(e) => handleChange("hour", e.target.value)}
            >
              <option value="">HH</option>
              {[...Array(24).keys()].map((h) => (
                <option key={h} value={h}>
                  {h.toString().padStart(2, "0")}
                </option>
              ))}
            </Form.Select>
          </FloatingLabel>
          <FloatingLabel
            controlId="floatingMinute"
            label={
              <>
                Minute <span className="text-danger">*</span>
              </>
            }
            className="custom-form-floating flex-fill mb-4"
          >
            <Form.Select
              value={remainders[index]["time"]?.minute}
              onChange={(e) => handleChange("minute", e.target.value)}
            >
              <option value="">MM</option>
              {[...Array(60).keys()].map((m) => (
                <option key={m} value={m}>
                  {m.toString().padStart(2, "0")}
                </option>
              ))}
            </Form.Select>
          </FloatingLabel>
        </Col>
      </Row>

      <div className="d-flex align-items-md-center gap-4 flex-wrap mb-4 flex-md-row flex-column">
        {typeOfChannel.map((option, idx) => {
          return (
            <div
              className="d-flex align-items-center gap-md-2 gap-3 justify-content-md-center justify-content-between"
              key={"checkbox-lbl" + idx}
            >
              <Form.Check
                type="checkbox"
                id={`dropdown-${option}-${idx}-${index}`}
                name={option}
                label={option.toUpperCase()}
                checked={remainders[index]["channels"][option] || false}
                onChange={handleCheckboxChange}
              />

              {remainders[index]["channels"][option] && (
                <FloatingLabel
                  controlId={`dropdown-${option}-${idx}-${index}`}
                  label={`${option.toUpperCase()} Template`}
                  className="custom-form-floating "
                >
                  <Form.Select
                    value={remainders[index]["template"][option]?.id || ""}
                    onChange={(e) => handleDropdownChange(e, option)}
                  >
                    <option value="">{`${option.toUpperCase()} Template`}</option>
                    {templateOptions[option]?.map((item, index) => (
                      <option key={index} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </Form.Select>
                </FloatingLabel>
              )}
            </div>
          );
        })}
      </div>

      <div className="d-flex justify-content-center align-items-center gap-2 flex-wrap">
        <Button
          variant="outline-danger"
          className="border-dashed"
          onClick={() =>
            setRemainders((prev) => prev.filter((_, i) => i !== index))
          }
          disabled={index === 0 && remainders.length < 2 ? true : false}
        >
          <span>{findIcon("Trash", "dual-tone", 22)}</span> Remove
        </Button>

        {remainders.length - 1 === index && (
          <Button
            variant="outline-primary"
            className="border-dashed"
            onClick={() =>
              setRemainders((prev) => [
                ...prev,
                {
                  time: {
                    day: "",
                    hour: "",
                    minute: "",
                  },
                  spqId: "",
                  template: {},
                  channels: {
                    sms: false,
                    email: false,
                    whatsapp: false,
                  },
                  surveyType: "",
                },
              ])
            }
            disabled={
              remainders.at(index)?.time?.day === "" &&
              remainders.at(index)?.time?.hour === "" &&
              remainders.at(index)?.time?.minute === ""
            }
          >
            <span>{findIcon("Plus", "solid", 22)}</span> Add Row
          </Button>
        )}
      </div>
    </div>
  );
};

export default EmslRemainder;
